//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import emailjs from "@emailjs/browser";

//Element
class Form extends Component {
    //Element
    O788K2 = async (e) => {
        //Element
        e.preventDefault()
        //Element
        emailjs.sendForm(process.env.REACT_APP_N04A4C, process.env.REACT_APP_Q919J2, "#Web_A01NB8", process.env.REACT_APP_W4961H)
            //Element
            .then((result) => {
                //Element
                if (result.text === "OK") {
                    //Element
                    let Form = document.getElementsByClassName("d4h85i")[0]
                    //Element
                    Form.classList.toggle("d-none")
                }
            }, (error) => {
                //Element
                let Form = document.getElementsByClassName("d4h85i")[0]
                //Element
                let Text = document.getElementsByClassName("y380pr")[0]
                //Element
                Form.classList.toggle("d-none")
                //Element
                Text.innerHTML = error.text
            })
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("form", { id: "Web_A01NB8", className: "S6pt64 C96Q4r pEO064 a527eB v9818w", method: "GET", onSubmit: this.O788K2 },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("input", { id: "Web_JX76F8", name: "Web_JX76F8", className: "S6pt64 C96Q4r pEO064 a527eB v4927z", placeholder: "Ad", type: "text", required: "required" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("input", { id: "Web_BQ324S", name: "Web_BQ324S", className: "S6pt64 C96Q4r pEO064 a527eB v4927z", placeholder: "Soyad", type: "text", required: "required" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("input", { id: "Web_H66D01", name: "Web_H66D01", className: "S6pt64 C96Q4r pEO064 a527eB v4927z", placeholder: "E-mail", type: "email", required: "required" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("input", { id: "Web_V53JE3", name: "Web_V53JE3", className: "S6pt64 C96Q4r pEO064 a527eB v4927z", placeholder: "Telefon", type: "tel", required: "required" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 12 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("textarea", { id: "Web_C89F0D", name: "Web_C89F0D", className: "S6pt64 C96Q4r pEO064 a527eB s5112i", rows: "5", cols: "30", placeholder: "Mesaj", required: "" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 12 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB hk360f" },
                        //Element
                        React.createElement("button", { id: "Web_J218KN", name: "Web_J218KN", className: "S6pt64 C96Q4r pEO064 a527eB e571tp", type: "submit" },
                            //Element
                            "Hemen Gönder"
                        )
                    )
                ),
                //Element
                React.createElement(Col, { md: 12 },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB d4h85i d-none" },
                        //Element
                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB y380pr" },
                            //Element
                            "Tüm Bilgiler Başarı İle Gönderildi."
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Form;